import { render, staticRenderFns } from "./RegisterBill.vue?vue&type=template&id=45aacbba&scoped=true&"
import script from "./RegisterBill.vue?vue&type=script&lang=js&"
export * from "./RegisterBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aacbba",
  null
  
)

export default component.exports